export function CalendarIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99568 1.99725H10.9952C11.1278 1.99725 11.2549 2.04991 11.3486 2.14366C11.4424 2.2374 11.4951 2.36455 11.4951 2.49712V10.4951C11.4951 10.6277 11.4424 10.7548 11.3486 10.8486C11.2549 10.9423 11.1278 10.995 10.9952 10.995H1.99743C1.86486 10.995 1.73771 10.9423 1.64397 10.8486C1.55022 10.7548 1.49756 10.6277 1.49756 10.4951V2.49712C1.49756 2.36455 1.55022 2.2374 1.64397 2.14366C1.73771 2.04991 1.86486 1.99725 1.99743 1.99725H3.99693V0.997498H4.99668V1.99725H7.99593V0.997498H8.99568V1.99725ZM7.99593 2.997H4.99668V3.99675H3.99693V2.997H2.49731V4.9965H10.4953V2.997H8.99568V3.99675H7.99593V2.997ZM10.4953 5.99625H2.49731V9.99525H10.4953V5.99625Z"
        fill="#001018"
      />
    </svg>
  )
}
